<template>
  <div class="container-list">
    <div class="common-page common-head" v-if="is_tap">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        {{ cpname }}单位报告
      </div>
      <div class="f-right">
        <div class="flex1"></div>

        <el-button v-hasPermi="['wenwu:report:add']" v-if="$store.state.user.userInfo.natureId == 2" icon="el-icon-plus" type="primary" @click="add">
          新增
        </el-button>
      </div>
    </div>
    <div class="ml20 f18 blue" v-if="is_tap && +$store.state.user.userInfo.natureId !== 2">
      <span class="cursor" @click="$router.back()">
        <i class="el-icon-back cursor"></i>
        返回
      </span>
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar"></div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="num" label="序号" align="center"></el-table-column>

          <el-table-column prop="xm_baogao_leixing" align="center" label="报告类型"></el-table-column>
          <!-- <el-table-column
                            prop="role_value"
                            align="center"
                            label="系统角色">
                    </el-table-column> -->
          <el-table-column prop="xm_suoshu" label="所属项目" v-if="false" align="center"></el-table-column>
          <el-table-column prop="xm_baogao_time" align="center" label="报告上传时间"></el-table-column>
          <el-table-column v-if="false" prop="xm_jiancha_user" align="center" label="检查人员"></el-table-column>
          <!-- <el-table-column prop="ce" align="center" label="数据统计">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: '/report/detail',
                  query: { id: scope.row.xm_uuid },
                }"
                v-hasPermi="['wenwu:reportdetail:query']"
              >
                <el-button type="primary" size="mini">详情</el-button>
              </router-link>
              <el-popconfirm
                title="确定执行此操作吗？"
                class="cursor"
                v-hasPermi="['wenwu:reportdetail:del']"
                @onConfirm="changeStatus(scope.row)"
                @confirm="changeStatus(scope.row)"
              >
                <a slot="reference"><el-button type="danger" size="mini">删除</el-button></a>
              </el-popconfirm>

              <!--                            <el-popconfirm title="确定删除吗？" class="cursor" @onConfirm="changeStatus(scope.row,2)">-->
              <!--                                <a slot="reference" class="red">-->
              <!--                                    删除-->
              <!--                                </a>-->
              <!--                            </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :page-size="params.limit || 10" @current-change="pageChange" :total="total"></el-pagination>
    </div>

    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="status == 1 ? '文件上传' : '修改'"
      :before-close="beforeClose"
      :visible.sync="addShowDia"
      :width="status == 1 ? '830px' : '500px'"
      ref="model"
      :close-on-click-modal="false"
    >
      <el-row :gutter="30" v-if="status == 1" v-loading="loading1">
        <el-col :span="13">
          <el-form :model="form" :rules="rules" ref="form" label-width="80px" size="small">
            <!-- <el-form-item label="单位名称" prop="basebg.bg_company_num">
              <el-select
                :disabled="isread"
                v-model="form.basebg.bg_company_num"
                filterable
                remote
                placeholder="请输入关键词"
                :loading="sloading"
              >
                <el-option
                  v-for="item in compList"
                  :key="item.c_company_num"
                  :label="item.c_name"
                  :value="item.c_company_num"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="项目名称" v-if="false" prop="xiangmubg.xm_suoshu">
              <!-- <el-input v-model="form.xiangmubg.xm_suoshu"></el-input> -->

              <el-select :disabled="isread" v-model="form.xiangmubg.xm_suoshu" filterable remote placeholder="请输入关键词">
                <el-option v-for="item in programList" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="报告名称" prop="xiangmubg.xm_baogao_name">
              <el-input v-model="form.xiangmubg.xm_baogao_name"></el-input>
            </el-form-item> -->
            <el-form-item label="报告类型" prop="xiangmubg.xm_baogao_leixing">
              <el-select v-model="form.xiangmubg.xm_baogao_leixing" filterable clearable>
                <el-option :label="item.mc_name" :value="item.mc_id" v-for="item in randomList"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="生成日期" prop="basebg.starttime">
              <el-date-picker v-model="form.basebg.starttime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="检查人员" v-if="false" prop="xiangmubg.xm_jiancha_user">
              <!-- <el-input :value="tr_address" ></el-input>
               -->

              <!-- <el-select multiple="" v-model="form.tr_per">
                
               </el-select> -->
              <el-input v-model="form.xiangmubg.xm_jiancha_user"></el-input>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-upload
                drag
                action="."
                :before-upload="handleBeforeUpload"
                :http-request="upload"
                multiple
                list-type="none"
                accept="*"
                :file-list="fileList1"
                :on-change="handleChange"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  可上传pdf或word文件,将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11">
          <el-card class="upload-box">
            <el-scrollbar style="height: 440px">
              <ul class="file-list">
                <li v-for="item in fileList" class="align-center">
                  <img src="@/assets/img/base.png" alt="" />
                  <div class="flex1">
                    <div class="mb5" :title="item.name">{{ item.name }}</div>
                    <div class="mb5">{{ (item.size / 1024 / 1024).toFixed(2) }}M</div>
                    <el-progress :percentage="+item.progress.toFixed(1)"></el-progress>
                  </div>
                  <i class="el-icon-close" @click="closeFile(item)"></i>
                </li>
              </ul>
            </el-scrollbar>
          </el-card>
        </el-col>
      </el-row>

      <div class="center">
        <el-button type="primary" @click="formSubmit" size="small" :loading="isUpload">提交</el-button>
        <!-- -->

        <el-button
          @click="
            beforeClose(() => {
              addShowDia = false;
            })
          "
          size="small"
        >
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getUserList, editUser } from "../api/user";
// import { get, post } from "@/utils/http.js";
import OSS from 'ali-oss';
import { parse } from 'querystring';
export default {
  props: ['is_tab', 'is_back'],
  data() {
    return {
      list: [],
      is_tap: true,
      isUpload: false,
      showTab: true,
      programList: [],
      loading1: false,
      form: {
        basebg: {
          bg_company_num: this.$route.query.id || this.$store.state.user.company.cCompanyNum,
          starttime: '',
        },
        xiangmubg: {
          xm_baogao_leixing: '',
          xm_suoshu: '',
          xm_jiancha_user: '',
        },
        wenjianbg: [],
      },
      rules: {
        'basebg.bg_company_num': [{ required: true, message: '请选择单位', trigger: 'blur' }],
        'xiangmubg.xm_suoshu': [{ required: true, message: '请选择所属项目', trigger: 'blur' }],

        'xiangmubg.xm_baogao_leixing': [{ required: true, message: '请选择类型', trigger: 'blur' }],

        'xiangmubg.xm_jiancha_user': [{ required: true, message: '请填写检查人员', trigger: 'blur' }],
        'basebg.starttime': [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      params: { page: 1, base_uuid: this.$route.query.id },
      total: 0,
      id: this.$route.query.id,
      fileType: ['pdf', 'doc', 'docx'],
      showDia: false,
      addShowDia: false,
      searchForm: this.$getForm('userSearch'),
      editData: {},
      remoteFuncs: {},
      cpname: '',
      isread: false,
      status: 1,
      fileList: {},
      randomList: [],
      formData: '',
      fileList1: [],
      url: [],
    };
  },

  created() {
    //   alert(this.is_tab)
    this.is_tap = this.is_tab;
    this.getList();
    this.$post('/dzda/allxiangmu', this.params).then((res) => {
      this.programList = res.data;
    });
    this.$post('/devicemanage/mapcode', { mc_parent_id: 232 }).then((res) => {
      this.randomList = res.data;
    });
  },
  methods: {
    handleBeforeUpload(file) {
      console.log(file, 'handleBeforeUpload');
      if (this.fileType) {
        let fileExtension = '';
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.toLowerCase().indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.toLowerCase().indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
          return false;
        }
      }
    },
    handleChange(file, fileList) {
      this.fileList1 = fileList;
      // console.log(this.fileList, "sb");
    },
    beforeClose(done) {
      if (this.isUpload) {
        this.$confirm('文件上传中，关闭将取消上传，是否取消', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            done();
            this.cancleUpload();
          })
          .catch(() => {});
      } else {
        done();
      }
    },
    upload(val) {
      // this.formData.append("file", val.file);

      // this.formData.append("file", file);
      let file = val.file;
      let id =
        // "/common/upload" +
        // // this.$config.dangan +
        // "/t" +
        Date.now() + 's' + file.size + '/' + file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        url: '',
        // client: client,
      });
      log(this.fileList, '111111111111111111111');

      let formData = new FormData();
      console.log(formData, 'formData');
      formData.append('file', file);
      console.log(formData, 'formData1');
      // formData.append("title", this.title);
      this.getTimes(file, id);
      console.log(file, 'file');

      this.$post('/common/upload', formData).then((res) => {
        this.fileList[id].progress = 100;
        this.fileList[id].uploading = false;
        this.fileList[id].url = res.data.url;
        //   this.$set(this.fileList, id, {
        //   key: res.data.url,
        //   // client: client,
        // });

        log(this.fileList, res, 'res');
        // this.fileList.key=res.data.url
        this.$notify({
          title: '上传成功',
          message: `${this.fileList[id].name}上传完成`,
          type: 'success',
        });
      });

      // console.log(val, "upload");
      // // let client = new OSS(this.$store.state.config.ossConfig);
      // let file = val.file;
      // let _this = this;
      // let id =
      // "/common/upload"+
      // // this.$config.dangan +
      // "/t" + Date.now() + "s" + file.size + "/" + file.name;
      // this.$set(this.fileList, id, {
      //   name: file.name,
      //   size: file.size,
      //   uploading: true,
      //   time: 0,
      //   progress: 0,
      //   key: id,
      //   // client: client,
      // });

      // 定义上传方法。
      // function multipartUpload() {
      //   _this.fileList[id].client
      //     .multipartUpload(id, file, {
      //       checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
      //       progress: (p, checkpoint, res) => {
      //         //log(p,checkpoint,res)
      //         if (checkpoint) {
      //           _this.fileList[id].progress = p * 100;
      //           _this.fileList[id].data = checkpoint;
      //         }
      //       },
      //       partSize: 1000 * 1024, //设置分片大小
      //       timeout: 120000, //设置超时时间
      //       mime: val.type,
      //     })
      //     .then((res) => {
      //       _this.fileList[id].progress = 100;
      //       _this.fileList[id].uploading = false;
      //       _this.$notify({
      //         title: "上传成功",
      //         message: `${_this.fileList[id].name}上传完成`,
      //         type: "success",
      //       });
      //     })
      //     .catch((err) => {
      //       if (
      //         err.code == "RequestError" ||
      //         err.code == "ConnectionTimeoutError"
      //       ) {
      //         //网络错误或超时
      //         setTimeout(multipartUpload, 3000);
      //       }
      //     });
      // }

      // multipartUpload();
    },
    getTimes(file, id) {
      //获取时长
      let content = file;
      // console.log(content,id, "conten");
      let url = URL.createObjectURL(content);
      console.log(url, 'url');
      let audioElement = new Audio(url);
      console.log(audioElement, 'audioElement');

      let time;
      let _this = this;
      audioElement.addEventListener('loadedmetadata', (_event) => {
        log(_event, '_event');
        if (!_this.fileList[id].time) {
          this.audioDuration = parseInt(audioElement.duration);
          time = this.audioDuration;
          _this.$set(_this.fileList[id], 'time', time);
        }
      });
    },
    formSubmit() {
      // if (this.status === 1) {
      //   console.log('走一下？');
      //   this.$refs.form.validate((valid) => {
      //     if (valid) {
      for (let key in this.fileList) {
        let data = this.fileList[key];
        console.log(key, data, 'key');
        this.form.wenjianbg.push({
          wj_name: data.name,
          wj_lujing: data.url,
        });
      }
      log(this.fileList, 'fileList');
      let params = this.form;
      console.log(params, 'params');
      this.isUpload = true;
      this.$post('/dzda/addbasebaogao', params).then((res) => {
        // if(){

        // }
        if (res.code == 200) {
          this.$message({
                message: res.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
          // this.$message.success(res.msg || '操作成功');
          this.addShowDia = false;
          this.cancleUpload();
          this.getList();
        }
      });
      // } else {
      //   return false;
      // }
      // });
      // }
    },

    cancleUpload() {
      this.fileList = {};
      this.form = {
        basebg: {
          bg_company_num: this.$route.query.id || this.$store.state.user.company.cCompanyNum,
          starttime: '',
        },
        xiangmubg: {
          xm_baogao_name: '',
          xm_baogao_leixing: '',
          xm_suoshu: '',
          xm_jiancha_user: '',
        },
        wenjianbg: [],
      };
      this.isUpload = false;
    },
    add(it, type) {
      console.log(it, type, 'add');
      this.isread = false;
      this.status = 1;
      this.addShowDia = true;
      if (type) {
        this.isread = true;
        this.loading1 = true;
        getDetail(it.tr_id)
          .then((res) => {
            let data = res.data;
            this.loading1 = false;
            this.tr_address = it.tr_address;
            this.form.tr_base.tr_project_name = data.tr_project_name;
            this.form.tr_base.tr_undertaker = data.tr_undertaker;
            this.form.tr_base.tr_assist = data.tr_assist;
            this.form.tr_base.tr_id = data.tr_id;
            this.form.tr_base.tr_type = data.tr_type;
            this.remoteMethod(it.tr_project_name);
          })
          .catch(() => {
            this.loading1 = false;
          });
      }
    },
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    changeStatus(it, del) {
      this.$post('/dzda/delxmbaogao', {
        xm_uuid: it.xm_uuid,
      }).then((res) => {

        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post('/dzda/allbasebaogao', this.params).then((res) => {
        this.cpname = res.basename;
        this.total = res.count;
        this.list = res.list;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}
</style>
